/* eslint-disable  */
//@ts-nocheck

import { useState } from 'react';
import auth from '@client/components/auth';
import { useGetScheduledWorkoutsQuery } from '../../../../generated/graphql';
import { browserHistory } from 'react-router';
import { Button } from '@design-system/components/button/button';
import { WorkoutList } from './components/WorkoutList';
import { WorkoutsPage } from './components/WorkoutsPage';

const PAGE_SIZE = 500;

const toProgramOrderKey = (w) => {
  // Mirrors OrderedProgram.workoutsOrder: day is in 1-7 range, week 0 = no
  // week/day prefix in the title (intro/overview workouts sort first).
  const week = w.name?.match(/^[Ww](\d+)/);
  const day = w.name?.match(/^[Ww]\d+\s*\/\s*[Dd](\d+)/);
  return (
    (week ? parseInt(week[1], 10) : 0) * 10 + (day ? parseInt(day[1], 10) : 0)
  );
};

const byProgramOrder = (a, b) => {
  if (
    a.programIndex != null &&
    b.programIndex != null &&
    a.programIndex !== b.programIndex
  ) {
    return a.programIndex - b.programIndex;
  }

  const orderDiff = toProgramOrderKey(a) - toProgramOrderKey(b);
  return orderDiff !== 0 ? orderDiff : a.id - b.id;
};

// The schedule modal historically saved publishedAt with wall-clock seconds,
// so batch-scheduled workouts differ at second precision while the UI only
// shows minutes. Compare at the displayed granularity and let program order
// decide within a minute.
const toScheduledMinute = (date) => Math.floor(Date.parse(date) / 60_000);

const byScheduledPublishDate = (a, b) => {
  if (!a.publishedAt && !b.publishedAt) return byProgramOrder(a, b);
  if (!a.publishedAt) return 1;
  if (!b.publishedAt) return -1;

  const diff =
    toScheduledMinute(a.publishedAt) - toScheduledMinute(b.publishedAt);
  return diff !== 0 ? diff : byProgramOrder(a, b);
};

export function ScheduledWorkoutsPage(props) {
  const influencerId = props.params.influencerId
    ? props.params.influencerId
    : auth.getUser().influencerId;

  const [offset, setOffset] = useState(0);

  const url = new URL(window.location.href);
  const shouldRefresh = url.searchParams.get('refresh');

  const {
    loading: isLoading,
    data,
    refetch,
  } = useGetScheduledWorkoutsQuery({
    variables: { id: parseInt(influencerId), limit: PAGE_SIZE + 1, offset },
    skip: !influencerId,
    fetchPolicy: shouldRefresh ? 'network-only' : 'cache-first',
    onCompleted: () => {
      if (shouldRefresh) {
        url.searchParams.delete('refresh');
        browserHistory.replace(url.href);
      }
    },
  });

  // Fetch one extra row to learn whether a further page exists, then drop it.
  const fetched = data?.creator?.scheduledWorkouts ?? [];
  const hasNextPage = fetched.length > PAGE_SIZE;
  const workouts = fetched.slice(0, PAGE_SIZE).sort(byScheduledPublishDate);
  const hasPrevPage = offset > 0;

  return (
    <WorkoutsPage
      isLoading={isLoading}
      creator={data ? data.creator : { id: influencerId }}
    >
      <WorkoutList
        type="scheduled"
        refreshWorkouts={refetch}
        workouts={workouts}
        influencerId={influencerId}
      />
      {(hasPrevPage || hasNextPage) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            padding: '16px 0',
          }}
        >
          <Button
            variant="outlined"
            disabled={!hasPrevPage}
            onClick={() => setOffset((o) => Math.max(0, o - PAGE_SIZE))}
          >
            Previous
          </Button>
          <Button
            variant="outlined"
            disabled={!hasNextPage}
            onClick={() => setOffset((o) => o + PAGE_SIZE)}
          >
            Next
          </Button>
        </div>
      )}
    </WorkoutsPage>
  );
}
